import { render } from "./TreeTable.vue?vue&type=template&id=19f8fb45"
import script from "./TreeTable.vue?vue&type=script&lang=js"
export * from "./TreeTable.vue?vue&type=script&lang=js"

import "./TreeTable.vue?vue&type=style&index=0&id=19f8fb45&lang=css"
script.render = render

export default script